// extracted by mini-css-extract-plugin
module.exports = {"myframe":"YoutubePopup_myframe__2CgKD","closeBtn":"YoutubePopup_closeBtn__3sFn_","header":"YoutubePopup_header__2GGcx","confirm":"YoutubePopup_confirm__JGPJq"};